import RequestTableInns from './RequestTableInnsContainer.vue';

export { RequestTableInns };



// WEBPACK FOOTER //
// ./src/modules/home/requestTableInns/index.js